import React from 'react';
import { Container, Tabs } from 'components';

const AuditLogEdit = () => {
  return (
    <Container.Tab>
      <Tabs />
    </Container.Tab>
  );
};

export default AuditLogEdit;